import { render } from "preact";
import { App } from "./app";
import "./styles/global.css";
import "./styles/map.css";
import "./styles/components.css";

const root = document.getElementById("app")!;
root.textContent = "";
render(<App />, root);

// Offline shell + data + tile-range cache. Production only: in dev the SW would
// cache module URLs out from under Vite's HMR.
if (import.meta.env.PROD && "serviceWorker" in navigator && (location.protocol === "https:" || location.hostname === "localhost" || location.hostname === "127.0.0.1")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(import.meta.env.BASE_URL + "sw.js").catch((e) => console.warn("SW registration failed", e));
  });
}
